
import ReactApexChart from 'react-apexcharts';
export const pieChart = (y,x,isMobile=false) =>{

  console.log(x)
  console.log(y)
     const options= {
       chart: {
         width: 580,
         type: 'donut',
       },
       colors: ['#93C3EE', '#77C3EE', '#669DB5', '#C0031B'],
       fill: {
        type: 'solid',
        colors: ['#8BD742', '#77C3EE', '#78AEFF', '#F74D52']
      },
       labels: y,
       plotOptions: {
         pie: {
           startAngle: -90,
           endAngle: 270,
           donut: {
            size: '50%',
            dataLabels: {
              enabled: false
            },
            labels: {
              show: true,
              name: {
                show: true,
                offsetY: 20,
                formatter: () => 'Orders'
              },
              value: {
                show: true,
                fontSize: '30px',
                fontFamily: 'Helvetica',
                fontWeight: 600,
                color: 'grey',
                offsetY: -10
              },
              total: {
                show: true,
                showAlways: true,
                color: '#BCC1C8',
                fontFamily: 'Helvetica',
                fontWeight: 600,
                formatter: (w) => {
                  const total = w.globals.seriesTotals.reduce(
                    (a, b) => a + b,
                    0
                  );
                  return `${total}`;
                }
              }
          }
         }
         
       }
      },
       dataLabels: {
         enabled: true
       },
       fill: {
         type: 'gradient',
       },
       legend: {
         formatter: function(val, opts) {
           return val + " - " + opts.w.globals.series[opts.seriesIndex]
         },
         show: !isMobile,
         position: 'right',
         offsetY:30,
       },
       
       title: {
         // text: 'Gradient Donut with custom Start-angle'
       },
       responsive: [{
         breakpoint: 900,
         options: {
           chart: {
             width: !isMobile ?500:230
           },
           legend: {
             position: 'top',
             show: !isMobile
           }
         }
       }]
     }
     return (
       <div>
          <ReactApexChart options={options} series={x} type="donut" width={420} />
       </div>
     )

  }